export const CLINICS = [
    {
        slug: "mumbai",
        title: "Nexus Clinic — Mumbai",
        address: "123 Marine Drive, Mumbai, Maharashtra",
        phone: "+91-22-1234-5678",
        hours: "Mon–Sat 9:00 AM – 6:00 PM",
        services: [
            "Outpatient Psychiatry",
            "Psychotherapy & Counselling",
            "Occupational & Speech Therapy",
            "Psychometric Testing"
        ],
        description: [
            "Our Mumbai centre combines city‑scale accessibility with specialist clinical care. The hub offers comprehensive outpatient services including psychiatric assessment, medication management and time‑limited psychotherapy packages. We prioritise rapid access and clear next‑step plans for every patient.",
            "The team at the Mumbai clinic comprises consultant psychiatrists, clinical psychologists and allied therapists who work together to deliver personalised treatment plans. Assessments are evidence‑based and include psychometric testing and neurocognitive batteries where appropriate to guide therapy and rehabilitation.",
            "We focus on collaborative care — involving families and local supports where relevant — and provide clear progress tracking so you and your clinician can see measurable improvements. The clinic also maintains referral pathways for advanced treatments and inpatient care when needed."
        ]
    },
    {
        slug: "centralmumbai",
        title: "Thane / Kalyan / Vashi — Central Mumbai Region",
        address: "Nexus Central Clinic, Thane Road, Thane",
        phone: "+91-22-2345-6789",
        hours: "Mon–Sat 9:00 AM – 5:30 PM",
        services: [
            "Day Programs & Rehab",
            "Child Development Assessments",
            "Family Therapy & School Liaison"
        ],
        description: [
            "Serving the central Mumbai belt, this clinic is designed for families and working adults who need structured, goal‑oriented care. We offer day programmes that combine therapy, skills training and functional rehabilitation to speed meaningful change.",
            "Our child development stream provides early assessment, tailored intervention packages and parent training to support learning and behaviour. Therapists coordinate with schools to ensure recommendations translate into everyday progress for the child.",
            "Care at this centre emphasises short, intensive courses with measurable targets, regular progress reports and active parental involvement so gains are reinforced at home and at school."
        ]
    },
    {
        slug: "newdelhi",
        title: "Nexus Clinic — New Delhi",
        address: "45 Connaught Place, New Delhi, Delhi",
        phone: "+91-11-2345-6789",
        hours: "Mon–Sat 10:00 AM – 6:00 PM",
        services: [
            "Adult Psychiatry",
            "Trauma‑informed Therapy",
            "Neuromodulation Referrals (Deep TMS/ECT)"
        ],
        description: [
            "Our New Delhi centre specialises in complex adult psychiatry and trauma‑informed care. Consultant psychiatrists lead diagnostic assessments and develop integrated plans that blend psychotherapy, medication and rehabilitative support.",
            "The Delhi clinic maintains streamlined referral pathways for neuromodulation treatments and multidisciplinary case reviews. We prioritise evidence‑based options and full informed consent for advanced procedures.",
            "Patients benefit from extended consultation slots, second‑opinion clinics and coordinated follow‑up so treatment plans remain responsive as recovery progresses."
        ]
    },
    {
        slug: "pune",
        title: "Nexus Clinic — Pune",
        address: "Plot 10, Koregaon Park, Pune, Maharashtra",
        phone: "+91-20-3456-7890",
        hours: "Mon–Sat 9:30 AM – 5:30 PM",
        services: [
            "Psychometric & Neurocognitive Testing",
            "Counselling & Short‑term Therapy",
            "Community Rehabilitation"
        ],
        description: [
            "The Pune clinic focuses on precise assessment and measurable therapy outcomes. Our testing lab offers standardized neurocognitive batteries and psychometric profiles to inform education, work and clinical recommendations.",
            "Therapeutic packages in Pune are pragmatic and skills‑based, emphasising symptom management, relapse prevention and functional recovery. Therapists use CBT, mindfulness and behaviour‑based approaches tailored to individual needs.",
            "We also run community rehabilitation and vocational support programmes to help people transition from clinical settings back into daily life and work with ongoing coaching and review."
        ]
    },
    {
        slug: "uttarpradesh",
        title: "Nexus Clinic — Uttar Pradesh (Regional Centre)",
        address: "Regional Centre, Lucknow, Uttar Pradesh",
        phone: "+91-522-3456-789",
        hours: "Mon–Sat 9:00 AM – 5:00 PM",
        services: [
            "Community Psychiatry & Outreach",
            "Child Development Clinics",
            "Local‑language Therapeutic Services"
        ],
        description: [
            "Our Uttar Pradesh regional clinic emphasises community engagement and accessible care. Services include outreach programmes, school screening and locally delivered therapy in regional languages to reduce barriers to access.",
            "The centre runs specialist child development clinics and family support pathways designed for rural and semi‑urban populations. Interventions are culturally sensitive and focused on practical outcomes for family functioning and school performance.",
            "We work closely with community health workers and schools to provide early identification, brief interventions and referral networks so that local families receive timely and sustained support."
        ]
    },
    {
        slug: "gujrat",
        title: "Nexus Clinic — Gujarat",
        address: "Gujarat Regional Clinic, Ahmedabad, Gujarat",
        phone: "+91-79-3456-7890",
        hours: "Mon–Sat 9:00 AM – 5:00 PM",
        services: [
            "Outpatient Psychiatry",
            "Addiction Support & Rehab",
            "Family Counselling"
        ],
        description: [
            "The Gujarat centre provides regionally tailored outpatient psychiatry and addiction support. Clinics combine medical management with psychosocial interventions and family work to support long‑term recovery.",
            "Addiction pathways include structured assessment, motivational interventions and relapse prevention planning. The team also collaborates with local rehabilitation services for step‑down care.",
            "Family counselling and caregiver training are core features — empowering families to support recovery, manage crises and maintain consistent aftercare once the intensive phase of treatment is complete."
        ]
    }
];